
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, list_type, option_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1, FormState_$reflection, RequestedValue$1_$reflection, ProblemReportId_$reflection, ToolId_$reflection, ClientApiResponse$1_$reflection, PostResponse$1_$reflection, EmptyResponse_$reflection } from "../../Shared/Shared.js";
import { ProblemReportState, ProblemReportCommentDto, ProblemReportSolvedDto, ProblemReportSolvedState, ProblemReportDeferDto, ProblemReportWatchersDto, ProblemReportWatcherCandidate_$reflection, ToolDetailDto_$reflection, ProblemReport_$reflection } from "../../Shared/Tool.js";
import { Receiver_$reflection } from "../../Shared/User.js";
import { getProblemReportsWithoutErrorPage, unwatchProblemReport, addProblemReportComment, solveProblemReport, resumeProblemReport, deferProblemReport, setProblemReportWatchers, getProblemReportWatcherCandidates, getProblemReports } from "../../Requests/ProblemReport.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_getToolDetailDto } from "../../Requests/Tool.js";
import { length, mapIndexed, concat as concat_1, reverse, exists, tryHead, filter, append, isEmpty, singleton, cons, tryFind, map as map_1, ofArray, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, orElse, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createObj, int32ToString, stringHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { List_distinctBy, List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { join, isNullOrWhiteSpace, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../UserPermissions.js";
import { Permissions_allowsInStorage, Permission, Permissions_has } from "../../Shared/Roles.js";
import { ChatInput, ChatFeed, ChatMessage, ChatEntry, ChatStatusEvent, ChatParticipant } from "../../Components/GroupChat.js";
import { StatusCard, StatusActionButton, statusDotColor, StatusTone } from "../../Components/StatusCard.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DetailItem, SidebarSection } from "../../Components/SidebarSection.js";
import { Avatar } from "../../Components/Avatar.js";
import { TextButton } from "../../Components/Button.js";
import Delete_Circle from "../../../public/assets/icons/Delete_Circle.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../../Widgets/Helper.js";
import { Dialog, ConfirmationDialog } from "../../Components/Dialog.js";
import { ProblemReportWatcherModal } from "./ProblemReportWatcherModal.js";
import { TextArea } from "../../Components/TextArea.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";
import Printer from "../../../public/assets/icons/Printer.svg";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetIsConfirmDialogOpen", "SetIsDeferDialogOpen", "SetIsResumeDialogOpen", "SetDeferReason", "DeleteProblemReport", "NewMessage", "CommentImageUploaded", "SolveProblemReport", "DeferProblemReport", "ResumeProblemReport", "ProblemReportResponse", "ProblemReportCommentSaved", "ProblemReportStateChanged", "ProblemReportsFetched", "ReceiverFetched", "ToolFetched", "WatcherCandidatesFetched", "SetIsAddWatcherDialogOpen", "AddWatchers", "RemoveWatcher", "WatchersSaved", "Unwatch", "Unwatched", "ProblemReportsAfterUnwatchFetched", "ProblemReportsAfterUnwatchFailed", "UnwatchFailed", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.ProblemReportDialog.Msg", [], Msg, () => [[], [], [], [["Item", string_type]], [], [["Item1", string_type], ["Item2", option_type(class_type("Browser.Types.File", undefined))]], [["Item1", string_type], ["Item2", FileUploadResponse_$reflection()]], [], [], [], [["Item", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [["Item", ProblemReport_$reflection()]], [["Item", ProblemReport_$reflection()]], [["Item", list_type(ProblemReport_$reflection())]], [["Item", list_type(Receiver_$reflection())]], [["Item", ToolDetailDto_$reflection()]], [["Item", list_type(ProblemReportWatcherCandidate_$reflection())]], [], [["Item", list_type(string_type)]], [["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(ProblemReport_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(ProblemReport_$reflection())]], [["Item", list_type(ProblemReport_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]]]);
}

function getProblemReportsCmd(toolId) {
    return getProblemReports(toolId, (Item) => (new Msg(13, [Item])), (Item_1) => (new Msg(26, [Item_1])));
}

function uploadCommentImageCmd(message, file) {
    const formData = new FormData();
    formData.append(file.name, file);
    return Cmd_uploadImage((response) => (new Msg(6, [message, response])), (Item) => (new Msg(26, [Item])), formData);
}

class State extends Record {
    constructor(ToolId, ProblemReportId, ProblemReports, FormState, SuccessCallback, OnClose, IsConfirmDialogOpen, IsDeferDialogOpen, IsResumeDialogOpen, DeferReason, Receivers, Tool, WatcherCandidates, IsAddWatcherDialogOpen) {
        super();
        this.ToolId = ToolId;
        this.ProblemReportId = ProblemReportId;
        this.ProblemReports = ProblemReports;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.IsConfirmDialogOpen = IsConfirmDialogOpen;
        this.IsDeferDialogOpen = IsDeferDialogOpen;
        this.IsResumeDialogOpen = IsResumeDialogOpen;
        this.DeferReason = DeferReason;
        this.Receivers = Receivers;
        this.Tool = Tool;
        this.WatcherCandidates = WatcherCandidates;
        this.IsAddWatcherDialogOpen = IsAddWatcherDialogOpen;
    }
}

function State_$reflection() {
    return record_type("Tools.ProblemReportDialog.State", [], State, () => [["ToolId", ToolId_$reflection()], ["ProblemReportId", ProblemReportId_$reflection()], ["ProblemReports", RequestedValue$1_$reflection(list_type(ProblemReport_$reflection()))], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["IsConfirmDialogOpen", bool_type], ["IsDeferDialogOpen", bool_type], ["IsResumeDialogOpen", bool_type], ["DeferReason", string_type], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Tool", RequestedValue$1_$reflection(ToolDetailDto_$reflection())], ["WatcherCandidates", RequestedValue$1_$reflection(list_type(ProblemReportWatcherCandidate_$reflection()))], ["IsAddWatcherDialogOpen", bool_type]]);
}

function init(toolId, successCallback, problemReportId, onClose) {
    return [new State(toolId, problemReportId, new RequestedValue$1(0, []), FormState_get_empty(), successCallback, onClose, false, false, false, "", new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), false), Cmd_batch(ofArray([getProblemReportsCmd(toolId), Cmd_getToolDetailDto((Item) => (new Msg(15, [Item])), (Item_1) => (new Msg(26, [Item_1])), toolId), getProblemReportWatcherCandidates(toolId, (Item_2) => (new Msg(16, [Item_2])), (_arg) => (new Msg(16, [empty()])))]))];
}

function currentWatcherIds(state) {
    const matchValue = state.ProblemReports;
    if (matchValue.tag === 0) {
        return empty();
    }
    else {
        return defaultArg(map((problemReport_1) => map_1((watcher) => watcher.UserId, problemReport_1.Watchers), tryFind((problemReport) => equals(problemReport.Id, state.ProblemReportId), matchValue.fields[0])), empty());
    }
}

function currentParticipantIds(state) {
    const matchValue = state.ProblemReports;
    if (matchValue.tag === 0) {
        return empty();
    }
    else {
        return defaultArg(map((problemReport_1) => List_distinct(cons(problemReport_1.SenderId, map_1((_arg) => _arg.SenderId, problemReport_1.Logs)), {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }), tryFind((problemReport) => equals(problemReport.Id, state.ProblemReportId), matchValue.fields[0])), empty());
    }
}

function saveWatchersCmd(state, userIds) {
    return setProblemReportWatchers(state.ProblemReportId, new ProblemReportWatchersDto(userIds), (Item) => (new Msg(20, [Item])), (Item_1) => (new Msg(26, [Item_1])));
}

function replaceProblemReport(state, updatedProblemReport) {
    const matchValue = state.ProblemReports;
    if (matchValue.tag === 0) {
        return new RequestedValue$1(0, []);
    }
    else {
        return new RequestedValue$1(1, [map_1((problemReport) => {
            if (equals(problemReport.Id, updatedProblemReport.Id)) {
                return updatedProblemReport;
            }
            else {
                return problemReport;
            }
        }, matchValue.fields[0])]);
    }
}

function update(msg, state) {
    let businessUnitId, FormState_13;
    switch (msg.tag) {
        case 1:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, !state.IsDeferDialogOpen, state.IsResumeDialogOpen, "", state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        case 2:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, !state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        case 3:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, msg.fields[0], state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        case 8:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), deferProblemReport(state.ProblemReportId, new ProblemReportDeferDto(state.DeferReason), (Item) => (new Msg(12, [Item])), (Item_1) => (new Msg(26, [Item_1])))];
        case 9:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), resumeProblemReport(state.ProblemReportId, (Item_2) => (new Msg(12, [Item_2])), (Item_3) => (new Msg(26, [Item_3])))];
        case 12:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, false, false, "", state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_batch(ofArray([getProblemReportsCmd(state.ToolId), Cmd_ofEffect((_arg) => {
                state.SuccessCallback();
            })]))];
        case 4:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        case 7: {
            const dto = new ProblemReportSolvedDto(state.ProblemReportId, "", new ProblemReportSolvedState(0, []), undefined);
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), solveProblemReport(dto, (Item_4) => (new Msg(10, [Item_4])), (Item_5) => (new Msg(26, [Item_5])))];
        }
        case 5:
            if (state.FormState.IsLoading) {
                return [state, Cmd_none()];
            }
            else if (msg.fields[1] == null) {
                const dto_1 = new ProblemReportCommentDto(msg.fields[0], undefined);
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), addProblemReportComment(state.ProblemReportId, dto_1, (Item_6) => (new Msg(11, [Item_6])), (Item_7) => (new Msg(26, [Item_7])))];
            }
            else {
                const file = msg.fields[1];
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), uploadCommentImageCmd(msg.fields[0], file)];
            }
        case 6:
            switch (msg.fields[1].tag) {
                case 0:
                    return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_errorToast("general.a_error_occured")];
                default:
                    return [state, addProblemReportComment(state.ProblemReportId, new ProblemReportCommentDto(msg.fields[0], msg.fields[1].fields[0].ImageUrl), (Item_8) => (new Msg(11, [Item_8])), (Item_9) => (new Msg(26, [Item_9])))];
            }
        case 10:
            if (msg.fields[0].tag === 1) {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, false, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_batch(ofArray([getProblemReportsCmd(state.ToolId), Cmd_ofEffect((_arg_1) => {
                    state.SuccessCallback();
                })]))];
            }
        case 11:
            return [state, Cmd_batch(ofArray([getProblemReportsCmd(state.ToolId), Cmd_ofEffect((_arg_2) => {
                state.SuccessCallback();
            })]))];
        case 13:
            return [new State(state.ToolId, state.ProblemReportId, new RequestedValue$1(1, [msg.fields[0]]), FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        case 14:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, new RequestedValue$1(1, [msg.fields[0]]), state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        case 15:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.WatcherCandidates, state.IsAddWatcherDialogOpen), (businessUnitId = msg.fields[0].BusinessUnitId, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
                    const pr = response_4.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
                }, refreshOn)))(true).then((_arg_3) => {
                    const result_1 = _arg_3;
                    return (result_1.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_1.fields[0]);
                    })())) : (Promise.resolve(result_1.fields[0]));
                });
            })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item_10) => (new Msg(14, [Item_10])), (Item_11) => (new Msg(26, [Item_11]))))];
        case 16:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, new RequestedValue$1(1, [msg.fields[0]]), state.IsAddWatcherDialogOpen), Cmd_none()];
        case 17:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, !state.IsAddWatcherDialogOpen), Cmd_none()];
        case 18:
            if (isEmpty(msg.fields[0])) {
                return [state, Cmd_none()];
            }
            else if (state.FormState.IsLoading) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), saveWatchersCmd(state, List_distinct(append(currentWatcherIds(state), msg.fields[0]), {
                    Equals: (x_1, y) => (x_1 === y),
                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                }))];
            }
        case 19:
            if (state.FormState.IsLoading) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), saveWatchersCmd(state, filter((watcherId) => (watcherId !== msg.fields[0]), currentWatcherIds(state)))];
            }
        case 20:
            if (msg.fields[0].tag === 1) {
                const message = defaultArg(orElse(map((validation) => validation.ErrorMessage, tryHead(msg.fields[0].fields[0].Validations)), msg.fields[0].fields[0].GlobalValidationMessage), "general.a_error_occured");
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_errorToast(message)];
            }
            else {
                return [(FormState_13 = FormState_get_empty(), new State(state.ToolId, state.ProblemReportId, replaceProblemReport(state, msg.fields[0].fields[0]), FormState_13, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, false)), Cmd_batch(ofArray([getProblemReportsCmd(state.ToolId), Cmd_ofEffect((_arg_4) => {
                    state.SuccessCallback();
                })]))];
            }
        case 21:
            if (state.FormState.IsLoading) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), unwatchProblemReport(state.ProblemReportId, (Item_12) => (new Msg(22, [Item_12])), (Item_13) => (new Msg(25, [Item_13])))];
            }
        case 22:
            if (msg.fields[0].tag === 1) {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return [new State(state.ToolId, state.ProblemReportId, replaceProblemReport(state, msg.fields[0].fields[0]), state.FormState, state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_batch(ofArray([getProblemReportsWithoutErrorPage(state.ToolId, (Item_14) => (new Msg(23, [Item_14])), (Item_15) => (new Msg(24, [Item_15]))), Cmd_ofEffect((_arg_5) => {
                    state.SuccessCallback();
                })]))];
            }
        case 23:
            if (exists((problemReport) => equals(problemReport.Id, state.ProblemReportId), msg.fields[0])) {
                return [new State(state.ToolId, state.ProblemReportId, new RequestedValue$1(1, [msg.fields[0]]), FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_ofEffect((_arg_6) => {
                    state.OnClose();
                })];
            }
        case 24:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_ofEffect((_arg_7) => {
                state.OnClose();
            })];
        case 25:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_errorToast("general.a_error_occured")];
        case 26:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
        default:
            return [new State(state.ToolId, state.ProblemReportId, state.ProblemReports, state.FormState, state.SuccessCallback, state.OnClose, !state.IsConfirmDialogOpen, state.IsDeferDialogOpen, state.IsResumeDialogOpen, state.DeferReason, state.Receivers, state.Tool, state.WatcherCandidates, state.IsAddWatcherDialogOpen), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems_13, elems_7, Title, elems_12, elems_8, elems_11, Label_12, Label_14, Label_15, Label_17;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canComment = Permissions_has(permissions, new Permission(37, []));
    const canSolve = Permissions_allowsInStorage(permissions, new Permission(39, []), props.UserData.UserId, props.Tool.StorageInformation.StorageId, props.Tool.StorageInformation.AssignedUserIds);
    const canEditWatchers = canSolve;
    const actionState = props.FormState.IsLoading ? "disabled" : "enabled";
    const receiverOf = (senderId) => tryFind((receiver) => (receiver.Id === senderId), props.Receivers);
    const senderName = (name, senderId_1) => {
        if (isNullOrWhiteSpace(name)) {
            return defaultArg(map((receiver_1) => receiver_1.Name, receiverOf(senderId_1)), "");
        }
        else {
            return name;
        }
    };
    const participants = map_1((tupledArg) => {
        const senderId_2 = tupledArg[1];
        return new ChatParticipant(senderId_2, senderName(tupledArg[0], senderId_2), defaultArg(map((receiver_2) => {
            const receiverType = receiver_2.ReceiverType;
            switch (receiverType.tag) {
                case 1:
                    return t("receivers.employee");
                case 2:
                    return t("receivers.externalperson");
                case 3:
                    return t("receivers.subcontractor");
                case 4:
                    return t("receivers.room");
                case 5:
                    return t("receivers.project");
                case 6:
                    return t("receivers.constructionsite");
                case 7:
                    return t("receivers.student");
                case 8:
                    return t("receivers.school_class");
                case 9:
                    return t("receivers.vehicles");
                case 10:
                    return t("receivers.api_receiver");
                default:
                    return t("receivers.user");
            }
        }, receiverOf(senderId_2)), ""));
    }, List_distinctBy((tuple) => tuple[1], cons([props.ProblemReport.Sender, props.ProblemReport.SenderId], map_1((log) => [log.Sender, log.SenderId], reverse(props.ProblemReport.Logs))), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
    const stateLabel = (state) => {
        switch (state.tag) {
            case 1:
                return t("tool.problem_report_state_solved");
            case 2:
                return t("tool.problem_report_state_deferred");
            default:
                return t("tool.problem_report_state_open");
        }
    };
    const stateTone = (state_1) => {
        switch (state_1.tag) {
            case 1:
                return new StatusTone(1, []);
            case 2:
                return new StatusTone(2, []);
            default:
                return new StatusTone(0, []);
        }
    };
    const statusEvent = (log_1, state_3) => (new ChatEntry(1, [new ChatStatusEvent(log_1.SenderId, log_1.Timestamp, stateLabel(state_3), statusDotColor(stateTone(state_3)))]));
    const entries = cons(new ChatEntry(0, [new ChatMessage("initial", props.ProblemReport.SenderId, props.ProblemReport.Timestamp, props.ProblemReport.Message, props.ProblemReport.ImageUrl)]), concat_1(mapIndexed((index, log_2) => {
        const message = (isNullOrWhiteSpace(log_2.Comment) && (log_2.ImageUrl == null)) ? empty() : singleton(new ChatEntry(0, [new ChatMessage(int32ToString(index), log_2.SenderId, log_2.Timestamp, log_2.Comment, log_2.ImageUrl)]));
        const matchValue = log_2.ProblemReportSolvedState;
        switch (matchValue.tag) {
            case 0:
                return cons(statusEvent(log_2, new ProblemReportState(1, [])), message);
            case 2:
                return cons(statusEvent(log_2, new ProblemReportState(2, [])), message);
            case 3:
                return cons(statusEvent(log_2, new ProblemReportState(0, [])), message);
            default:
                return message;
        }
    }, props.ProblemReport.Logs)));
    const markSolvedButton = createElement(StatusActionButton, {
        ComponentState: actionState,
        IsPrimary: true,
        Label: t("tool.tool_problem_report_mark_solved"),
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "solve-problem-report-dialog-test-id",
    });
    const deferButton = createElement(StatusActionButton, {
        ComponentState: actionState,
        IsPrimary: false,
        Label: t("tool.tool_problem_report_defer"),
        OnClick: () => {
            props.Dispatch(new Msg(1, []));
        },
        TestId: "defer-problem-report-dialog-test-id",
    });
    const reopenButton = createElement(StatusActionButton, {
        ComponentState: actionState,
        IsPrimary: false,
        Label: t("tool.tool_problem_report_resume"),
        OnClick: () => {
            props.Dispatch(new Msg(2, []));
        },
        TestId: "resume-problem-report-dialog-test-id",
    });
    let statusActions;
    const matchValue_1 = props.ProblemReport.State;
    statusActions = ((matchValue_1.tag === 2) ? ofArray([reopenButton, markSolvedButton]) : ((matchValue_1.tag === 1) ? singleton(reopenButton) : ofArray([markSolvedButton, deferButton])));
    const watcherName = (watcher) => {
        if (isNullOrWhiteSpace(watcher.Name)) {
            return defaultArg(orElse(map((candidate_1) => candidate_1.Name, tryFind((candidate) => (candidate.UserId === watcher.UserId), props.WatcherCandidates)), map((receiver_3) => receiver_3.Name, receiverOf(watcher.UserId))), "");
        }
        else {
            return watcher.Name;
        }
    };
    const reportedAt = (toString(toLocalTime(props.ProblemReport.Timestamp), "dd.MM.yyyy, HH:mm") + " ") + t("general.clock");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_13 = [reactElement("div", createObj(ofArray([["className", join(" ", ["hidden", "print:block", "p-4"])], (elems_7 = [createElement(PropertyList, (Title = t("general.master_data"), {
        Properties: toList(delay(() => append_1(singleton_1({
            Label: t("tool.manufacturer"),
            TestId: "master-data-manufacturer",
            Value: props.Tool.MasterData.Manufacturer,
        }), delay(() => append_1(singleton_1({
            Label: t("tool.model"),
            TestId: "master-data-model",
            Value: props.Tool.MasterData.Model,
        }), delay(() => append_1(singleton_1({
            Label: t("tool.serial_number"),
            TestId: "master-data-serial-number",
            Value: props.Tool.MasterData.SerialNumber,
        }), delay(() => append_1(singleton_1({
            Label: t("tool.displayname"),
            TestId: "master-data-display-name",
            Value: props.Tool.MasterData.DisplayName,
        }), delay(() => append_1(singleton_1({
            Label: t("tool.inventory_number"),
            TestId: "master-data-inventory-number",
            Value: props.Tool.MasterData.InventoryNumber,
        }), delay(() => append_1(singleton_1({
            Label: t("general.comment"),
            TestId: "master-data-comment",
            Value: props.Tool.MasterData.Comment,
        }), delay(() => append_1(singleton_1({
            Label: t("tool.last_check"),
            TestId: "master-data-last-check",
            Value: defaultArg(map((lastInspectionDate) => toString(toLocalTime(lastInspectionDate), "dd.MM.yyyy"), props.Tool.MasterData.LastInspectionDate), ""),
        }), delay(() => {
            if (props.UserData.Customer.tag === 1) {
                const matchValue_3 = props.Tool.CustomerSpecific;
                switch (matchValue_3.tag) {
                    case 1:
                        return singleton_1({
                            Label: t("tool.prinzing.check_number"),
                            TestId: "master-data-prinzing-check-number",
                            Value: matchValue_3.fields[0].CheckNumber,
                        });
                    default: {
                        return empty_1();
                    }
                }
            }
            else {
                return empty_1();
            }
        })))))))))))))))),
        Title: unwrap(Title),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "md:flex-row", "grow", "min-h-0", "h-[calc(100%-4rem)]"])], (elems_12 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1", "min-w-0", "min-h-0"])], (elems_8 = toList(delay(() => append_1(singleton_1(createElement(ChatFeed, {
        CurrentUserId: props.UserId,
        EmptyText: t("general.no_content"),
        Entries: entries,
        Participants: participants,
    })), delay(() => {
        let Placeholder, SendLabel;
        return canComment ? singleton_1(createElement(ChatInput, (Placeholder = t("chat.message_to_participants_placeholder"), (SendLabel = t("chat.send"), {
            AttachTitle: t("chat.attach_file"),
            CanAttachImage: true,
            FormState: props.FormState,
            OnSubmit: (value_49, image) => {
                props.Dispatch(new Msg(5, [value_49, image]));
            },
            Placeholder: Placeholder,
            SendLabel: SendLabel,
        })))) : empty_1();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("div", createObj(ofArray([["data-test-id", "problem-report-sidebar"], ["className", join(" ", ["md:w-[270px]", "shrink-0", "border-t", "md:border-t-0", "md:border-l", "border-[#EAEAEA]", "bg-[#FAFAFA]", "p-[22px]", "flex", "flex-col", "gap-[22px]", "overflow-auto"])], (elems_11 = [createElement(SidebarSection, (Label_12 = t("general.state"), {
        Children: toList(delay(() => {
            let Label_13, Tone, state_2;
            return append_1(singleton_1(createElement(StatusCard, (Label_13 = stateLabel(props.ProblemReport.State), (Tone = stateTone(props.ProblemReport.State), {
                Label: Label_13,
                TestId: "problem-report-status-card-" + ((state_2 = props.ProblemReport.State, (state_2.tag === 1) ? "solved" : ((state_2.tag === 2) ? "deferred" : "open"))),
                Tone: Tone,
            })))), delay(() => (canSolve ? singleton_1(reactElement("div", {
                className: join(" ", ["flex", "flex-col", "gap-2", "print:hidden"]),
                children: reactApi.Children.toArray(Array.from(statusActions)),
            })) : empty_1())));
        })),
        IsFirst: true,
        Label: Label_12,
        TestId: "problem-report-status-section",
    })), createElement(SidebarSection, (Label_14 = ((t("tool.problem_report_participants") + " · ") + int32ToString(length(participants))), {
        Children: map_1((participant) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["data-test-id", "problem-report-participant"], ["className", join(" ", ["flex", "items-center", "gap-[10px]"])], (elems_1 = [createElement(Avatar, {
                Id: participant.Id,
                Name: participant.Name,
                Size: 30,
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "min-w-0"])], (elems = [reactElement("div", {
                className: join(" ", ["text-[14px]", "font-semibold", "truncate"]),
                children: participant.Name,
            }), reactElement("div", {
                className: join(" ", ["text-[12px]", "text-[#777777]"]),
                children: join(" · ", toList(delay(() => append_1((participant.Role !== "") ? singleton_1(participant.Role) : empty_1(), delay(() => ((participant.Id === props.UserId) ? singleton_1(t("chat.you")) : empty_1())))))),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        }, participants),
        IsFirst: false,
        Label: Label_14,
        TestId: "problem-report-participants",
    })), createElement(SidebarSection, (Label_15 = ((t("tool.problem_report_watchers") + " · ") + int32ToString(length(props.ProblemReport.Watchers))), {
        Children: toList(delay(() => append_1(map_1((watcher_1) => {
            let elems_6;
            return reactElement("div", createObj(ofArray([["data-test-id", "problem-report-watcher"], ["className", join(" ", ["flex", "items-center", "gap-[10px]"])], (elems_6 = toList(delay(() => append_1(singleton_1(createElement(Avatar, {
                Id: watcher_1.UserId,
                Name: watcherName(watcher_1),
                Size: 30,
            })), delay(() => {
                let elems_2;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "min-w-0", "grow"])], (elems_2 = toList(delay(() => append_1(singleton_1(reactElement("div", {
                    "data-test-id": "problem-report-watcher-name",
                    className: join(" ", ["text-[14px]", "font-semibold", "truncate"]),
                    children: watcherName(watcher_1),
                })), delay(() => ((watcher_1.UserId === props.UserId) ? singleton_1(reactElement("div", {
                    className: join(" ", ["text-[12px]", "text-[#777777]"]),
                    children: t("chat.you"),
                })) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3, elems_5, elems_4;
                    return (watcher_1.UserId === props.UserId) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["shrink-0", "print:hidden"])], (elems_3 = [createElement(TextButton, {
                        ComponentState: actionState,
                        Label: t("tool.problem_report_unwatch"),
                        OnClick: () => {
                            props.Dispatch(new Msg(21, []));
                        },
                        TestId: "problem-report-unwatch",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : (canEditWatchers ? singleton_1(reactElement("button", createObj(ofArray([["data-test-id", "problem-report-remove-watcher"], ["className", join(" ", ["shrink-0", "h-4", "w-4", "text-[#777777]", "hover:text-icon-red", "print:hidden"])], ["title", t("tool.problem_report_remove_watcher")], ["disabled", props.FormState.IsLoading], ["onClick", (_arg_4) => {
                        props.Dispatch(new Msg(19, [watcher_1.UserId]));
                    }], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_4 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty_1());
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
        }, props.ProblemReport.Watchers), delay(() => {
            let elems_10;
            return canEditWatchers ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_10 = [createElement(TextButton, {
                ComponentState: actionState,
                Label: t("tool.problem_report_add_watcher"),
                OnClick: () => {
                    props.Dispatch(new Msg(17, []));
                },
                TestId: "problem-report-add-watcher",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty_1();
        })))),
        IsFirst: false,
        Label: Label_15,
        TestId: "problem-report-watchers",
    })), createElement(SidebarSection, (Label_17 = t("tool.problem_report_details"), {
        Children: toList(delay(() => append_1(singleton_1(createElement(DetailItem, {
            Label: t("tool.problem_report_registered_on"),
            TestId: "problem-report-detail-registered-on",
            Value: reportedAt,
        })), delay(() => append_1(singleton_1(createElement(DetailItem, {
            Label: t("tool.problem_report_reported_by"),
            TestId: "problem-report-detail-reported-by",
            Value: senderName(props.ProblemReport.Sender, props.ProblemReport.SenderId),
        })), delay(() => (!isNullOrWhiteSpace(props.ProblemReport.Solver) ? singleton_1(createElement(DetailItem, {
            Label: t("tool.problem_report_solved_by"),
            TestId: "problem-report-detail-solved-by",
            Value: props.ProblemReport.Solver,
        })) : empty_1()))))))),
        IsFirst: false,
        Label: Label_17,
        TestId: "problem-report-details",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

export function ProblemReportDialog(props) {
    let elems_1, Title, Title_1, matchValue, Title_2, elems, matchValue_1, matchValue_2, matchValue_3, matchValue_4, matchValue_6;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.ToolId, props.SuccessCallback, props.ProblemReportId, props.OnClose);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const deferComponentState = state_2.FormState.IsLoading ? "disabled" : "enabled";
    const addWatcherComponentState = state_2.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(singleton((elems_1 = [createElement(ConfirmationDialog, (Title = t("tool.tool_problem_report_solved"), {
        Description: t("tool.dialog_problem_report_confirm_question"),
        FormState: state_2.FormState,
        IsOpen: state_2.IsConfirmDialogOpen,
        OnClose: () => {
            dispatch(new Msg(0, []));
        },
        OnConfirm: () => {
            dispatch(new Msg(7, []));
        },
        Title: Title,
    })), createElement(ConfirmationDialog, (Title_1 = t("tool.tool_problem_report_resume"), {
        Description: t("tool.dialog_problem_report_resume_question"),
        FormState: state_2.FormState,
        IsOpen: state_2.IsResumeDialogOpen,
        OnClose: () => {
            dispatch(new Msg(2, []));
        },
        OnConfirm: () => {
            dispatch(new Msg(9, []));
        },
        Title: Title_1,
    })), createElement(ProblemReportWatcherModal, {
        Candidates: (matchValue = state_2.WatcherCandidates, (matchValue.tag === 0) ? empty() : matchValue.fields[0]),
        ComponentState: addWatcherComponentState,
        ExistingWatcherIds: currentWatcherIds(state_2),
        IsOpen: state_2.IsAddWatcherDialogOpen,
        OnAdd: (arg) => {
            dispatch(new Msg(18, [arg]));
        },
        OnClose: () => {
            dispatch(new Msg(17, []));
        },
        ParticipantIds: currentParticipantIds(state_2),
    }), createElement(Dialog, (Title_2 = t("tool.dialog_problem_report_defer_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = [reactElement("p", {
            children: t("tool.dialog_problem_report_defer_description"),
        }), createElement(TextArea, {
            ComponentState: deferComponentState,
            Label: t("tool.dialog_problem_report_defer_reason"),
            OnChange: (value_3) => {
                dispatch(new Msg(3, [value_3]));
            },
            TestId: "defer-problem-report-reason-test-id",
            Value: state_2.DeferReason,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: deferComponentState,
            Label: t("general.cancel"),
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "cancel-defer-problem-report-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: deferComponentState,
            Label: t("tool.tool_problem_report_defer"),
            OnClick: () => {
                dispatch(new Msg(8, []));
            },
            TestId: "confirm-defer-problem-report-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: state_2.IsDeferDialogOpen,
        OnClose: () => {
            dispatch(new Msg(1, []));
        },
        Title: Title_2,
    })), createElement(ModalSheet, {
        CloseButtonTestId: "problem-report-modal-sheet-test-id",
        Content: (matchValue_1 = state_2.ProblemReports, (matchValue_2 = state_2.Receivers, (matchValue_3 = state_2.Tool, (matchValue_4 = state_2.WatcherCandidates, (matchValue_1.tag === 0) ? createElement(ModalSheet, {
            CloseButtonTestId: "tool-problem-report-dialog-modal-sheet-test-id",
            Content: createElement(Skeleton, {
                Variant: "detail",
            }),
            Controls: empty(),
            IsModalOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: t("tool.current_problem_report"),
        }) : ((matchValue_2.tag === 0) ? createElement(ModalSheet, {
            CloseButtonTestId: "tool-problem-report-dialog-modal-sheet-test-id",
            Content: createElement(Skeleton, {
                Variant: "detail",
            }),
            Controls: empty(),
            IsModalOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: t("tool.current_problem_report"),
        }) : ((matchValue_3.tag === 0) ? createElement(ModalSheet, {
            CloseButtonTestId: "tool-problem-report-dialog-modal-sheet-test-id",
            Content: createElement(Skeleton, {
                Variant: "detail",
            }),
            Controls: empty(),
            IsModalOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: t("tool.current_problem_report"),
        }) : ((matchValue_4.tag === 0) ? createElement(ModalSheet, {
            CloseButtonTestId: "tool-problem-report-dialog-modal-sheet-test-id",
            Content: createElement(Skeleton, {
                Variant: "detail",
            }),
            Controls: empty(),
            IsModalOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: t("tool.current_problem_report"),
        }) : ((matchValue_6 = tryFind((pr) => equals(pr.Id, state_2.ProblemReportId), matchValue_1.fields[0]), (matchValue_6 == null) ? "" : createElement(DialogBody, {
            Dispatch: dispatch,
            FormState: state_2.FormState,
            ProblemReport: matchValue_6,
            Receivers: matchValue_2.fields[0],
            SuccessCallback: props.SuccessCallback,
            Tool: matchValue_3.fields[0],
            UserData: props.UserData,
            UserId: props.UserId,
            WatcherCandidates: matchValue_4.fields[0],
        })))))))))),
        Controls: singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Icon: Printer(),
            Label: "",
            OnClick: () => {
                window.print();
            },
            TestId: "problem-report-print-button",
            Variant: "default",
        })),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: t("tool.current_problem_report"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

